import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TCustomerFormParamsLayoutService = {
  payload: {
    paramsType?: string
  }
}

export const customerFormParamsLayoutService = async ({
  payload,
}: TCustomerFormParamsLayoutService): Promise<ResponseAPI> => {
  const response = await api.get(`parametroslayout/${payload.paramsType}`)
  return response.data
}
